export default (function (_ref) {
  var request = _ref.request;
  return {
    aeratorControlItemAdd: function aeratorControlItemAdd(data) {
      return request({
        url: '/iot/controlItem',
        method: 'post',
        data: data,
        service: 'iot'
      });
    },
    aeratorControlItemModify: function aeratorControlItemModify(data) {
      return request({
        url: "/iot/controlItem/".concat(data.id),
        method: 'put',
        data: data,
        service: 'iot'
      });
    },
    aeratorControlItemDel: function aeratorControlItemDel(id) {
      return request({
        url: "/iot/controlItem/".concat(id),
        method: 'delete',
        service: 'iot'
      });
    },
    aeratorControlItemQuery: function aeratorControlItemQuery(data) {
      return request({
        url: '/iot/controlItem',
        method: 'get',
        params: data,
        service: 'iot'
      });
    },
    aeratorControlItemDetail: function aeratorControlItemDetail(id) {
      return request({
        url: "/iot/controlItem/".concat(id),
        method: 'get',
        service: 'iot'
      });
    }
  };
});